export default __webpack_public_path__ + "static/media/waldorf.f725f4a2.jpg";